import moment from "moment";
import UnitConverter from "./../../utils/UnitConverter";
import {
	area,
	areaLineRange,
	areaSpline,
	areaSplineRange,
	areaStep,
	bar,
	bubble,
	line,
	scatter,
	spline,
	step
} from "billboard.js";

const SERIES_TYPES = {
	area: area(),
	areaLineRange: areaLineRange(),
	areaSpline: areaSpline(),
	areaSplineRange: areaSplineRange(),
	areaStep: areaStep(),
	bar: bar(),
	bubble: bubble(),
	line: line(),
	scatter: scatter(),
	spline: spline(),
	step: step()
};
export default {
	/**
	 * get deviation Icon state
	 */
	getDeviationIconState(devType) {
		// devType === "negative" ? "error" : "success";
		if (!this.enableDeviationColor) {
			return "default";
		} else if (
			(devType === "negative" && this.invertDeviationColor) ||
			(devType === "positive" && !this.invertDeviationColor)
		) {
			return "success";
		} else {
			return "error";
		}
	},
	/**
	 * Calculating how many ticks will fit on X Axis
	 */
	getXTickCount() {
		const width = this.getSize().width;
		/**
		 * tickLabelWidth will vary or based on tickFormat
		 */
		const tickLabelWidth = 80;
		let count = (width / tickLabelWidth).toFixed(0);

		if (count < 2) {
			count = 2;
		}
		return count;
	},
	/**
	 * Calculating how many ticks will fit on Y Axis
	 */ getYTickCount() {
		const height = this.getSize().height;
		/**
		 * tickLabelheight is based on lineheight
		 */
		const tickLabelheight = 30;
		let count = (height / tickLabelheight).toFixed(0);

		if (count < 2) {
			count = 2;
		}
		return count;
	},
	/**
	 * Calculating tick values
	 */ getTickValues() {
		// const tickCount = +this.getXTickCount();

		const tickValues = [];
		if (this.chart) {
			/**
			 * Retrieve Series names
			 */
			const seriesNames = Object.keys(this.chart.x() ? this.chart.x() : {});

			if (seriesNames.length > 0) {
				// getting x axis values
				const xValues = this.chart.x()[seriesNames[0]];

				// min value on x axis
				const minX = xValues[0].getTime();
				// max value on x axis
				const maxX = xValues[xValues.length - 1].getTime();

				// calculating first tick & last tick
				const firstTick = moment(minX).add(2, "minute");
				const lastTick = moment(maxX).subtract(2, "minute");

				// duration in first last tick
				// const duration = lastTick.diff(firstTick, "minute");
				//console.log(duration);
				// Calculating tick interval based on duration and tick count
				const tickInterval = 5; //+(duration / tickCount).toFixed(0);
				if (this.tickInterval == 0) {
					//first time saving this interval for consitancy
					this.tickInterval = tickInterval;
				}
				//	console.log(tickCount, tickInterval);
				if (+firstTick.format("x") > this.tickGreaterThan) {
					tickValues.push(+firstTick.format("x"));
				}

				// for (let i = 1; i < tickCount; i++) {

				// }

				while (lastTick.diff(firstTick, "minute") >= this.tickInterval) {
					const tValue = +firstTick.add(this.tickInterval, "minute").format("x");
					if (tValue > this.tickGreaterThan) {
						tickValues.push(tValue);
					}
				}

				//	tickValues.push(+lastTick.format("x"));
				//	console.log(tickValues);
			}
		}
		//console.log(tickValues);
		return tickValues;
		// for (let i = 0; i < tickCount; i++) {
		// 	tickValues.push();
		// }
	},
	/**
	 * Get size fo container
	 */
	getSize() {
		if (this.$refs.chartdom) {
			return {
				width: this.$refs.chartdom.offsetWidth,
				height: this.empty
					? this.$refs.chartdom.offsetHeight
					: this.$refs.chartdom.offsetHeight - 60
			};
		} else {
			return {
				width: 100,
				height: 100
			};
		}
	},
	/**
	 *
	 * @returns {number} number of max ticks can plot
	 */
	getXMaxCulling() {
		const minTicks = 5;
		const maxTcks = 13;
		let ticksCanPlot = +(this.getSize().width / 100).toFixed(0) + 1;
		if (ticksCanPlot < minTicks) {
			ticksCanPlot = minTicks;
		}
		if (ticksCanPlot > maxTcks) {
			ticksCanPlot = maxTcks;
		}
		return ticksCanPlot;
	},
	/**
	 * Build tolltip options
	 */ getTooltip() {
		return {
			contents: (data, defaultTitleFormat, defaultValueFormat, color) => {
				const tooltipData = {
					title: null,
					points: []
				};
				const yAxisUnit = point => {
					const axisName = this.series.find(sr => sr.name === point.name).yAxisName;
					return this.yAxisUnits[axisName ? axisName : "y"];
				};
				const yAxisName = point => {
					const axisName = this.series.find(sr => sr.name === point.name).yAxisName;
					return axisName ? axisName : "y";
				};
				const label = point => {
					const label_ = this.series.find(sr => sr.name === point.name).label;
					return label_ ? label_ : point.name;
				};

				//	console.log(this.maxValues);

				data.forEach(d => {
					tooltipData.title = d.x;
					tooltipData.points.push({
						name: label(d),
						value: UnitConverter.convertAndFormat(
							d.value,
							yAxisUnit(d),
							this.maxValues[yAxisName(d)].unit,
							{
								toFixed: 3,
								space: true,
								normalize: false
							}
						),
						color: color(d),
						index: d.index
					});
				});

				const tooltipInstance = new this.tooltip({ data: tooltipData });
				return tooltipInstance.$mount().$el.outerHTML;
			},
			grouped: this.groupedTooltip,
			linked: this.linkedTooltip
		};
	},
	/**
	 * Build y axis options
	 */
	getYAxisConfig(axisName) {
		return {
			tick: {
				culling: {
					max: this.getYTickCount()
				},
				format: value => {
					return this.formatYLabel(value, axisName);
				}
			},
			padding: {
				bottom: 0
			}
		};
	},
	/**
	 * Used to format Y label values. Also this is used in formatting threshold label values
	 * @param {*} value value
	 * @param {*} axisName axis name either 'y' or 'y2'
	 * @returns {String} formatted Y label
	 */
	formatYLabel(value, axisName) {
		let toFixed = 2;
		if (value < 1) {
			toFixed = -Math.floor(Math.log10(value));
			if (toFixed <= 0) {
				toFixed = 2;
			}
			if (toFixed === Infinity || `${toFixed}` === "NaN") {
				toFixed = 0;
			}
			toFixed += 1;
		}

		return UnitConverter.convertAndFormat(
			value,
			this.yAxisUnits[axisName] ? this.yAxisUnits[axisName] : "COUNT._",
			this.maxValues[axisName].unit ? this.maxValues[axisName].unit : "COUNT._",
			{
				toFixed,
				space: true,
				normalize: false
			}
		);
	},
	/**
	 * get data for billboard
	 */ getData() {
		const columns = [];
		const axes = {};
		const xAxisSet = new Set();
		const colors = {};
		const types = {};
		if (this.series) {
			this.series.forEach(sr => {
				const x_data_name = `${sr.name}_x`;
				const yColumn = [sr.name]; // y axis data for this series
				const xColumn = [x_data_name]; // x axis data for this series

				colors[sr.name] = sr.color;
				/**
				 * Adding data points
				 */
				if (sr.points) {
					sr.points.forEach(point => {
						xAxisSet.add(point.x);
						xColumn.push(point.x);
						yColumn.push(point.y);
					});
				}
				columns.push(yColumn);

				this.lastX[sr.name] = xColumn[xColumn.length - 1];

				/**
				 * START : Settings Y axis configuration
				 */
				if (sr.yAxisName) {
					axes[sr.name] = sr.yAxisName;

					//set Axis type
					if (sr.yAxisUnit) {
						this.yAxisUnits[sr.yAxisName] = sr.yAxisUnit;
					}
					// Enable secondary Y axis
					if (sr.yAxisName === "y2") {
						this.showY2 = true;
					}
				} else {
					axes[sr.name] = "y";

					//set Axis type
					if (sr.yAxisUnit) {
						this.yAxisUnits.y = sr.yAxisUnit;
					}
				}
				/**
				 * END : Settings Y axis configuration
				 */

				if (sr.type) {
					types[sr.name] = SERIES_TYPES[sr.type];
				} else {
					types[sr.name] = line();
				}
			});
		}

		const xAxis = ["X_AXIS", ...xAxisSet];
		columns.push(xAxis);
		return { x: "X_AXIS", columns, colors, axes, types };
	},
	/**
	 * get threshold lines if any
	 */ getThresholdLines() {
		const lines = [];
		if (this.series) {
			this.series.forEach(sr => {
				if (sr.thresholdLines) {
					sr.thresholdLines.forEach(tline => {
						lines.push({
							value: tline.value,
							text: tline.text
								? this.formatThresholdLabel(
										sr.axisName ? sr.axisName : "y",
										tline.value,
										tline.text
								  )
								: `> ${tline.value}`,
							position: tline.position ? tline.position : "end",
							class: `flow-timeseries-${tline.type}`
						});
					});
				}
			});
		}

		return { lines };
	},
	/**
	 * Used to format threshold line label
	 * @param {*} axisName 'y' | 'y2'
	 * @param {*} value
	 * @param {*} templateText template text must have '${threshold}' keyword
	 * @returns {String} formatted String
	 */
	formatThresholdLabel(axisName, value, templateText) {
		const formattedValue = this.formatYLabel(value, axisName);

		const reg = new RegExp("\\$\\{threshold\\}", "g");

		return templateText.replace(reg, formattedValue);
	},
	/**
	 * get event lines if any
	 */
	getEventLines() {
		const lines = [];
		if (this.eventLines) {
			this.eventLines.forEach(vline => {
				lines.push({
					value: vline,
					class: "flow-timeseries-event-line"
				});
			});
		}

		return { lines };
	},
	getLatestValue(series) {
		// console.log(series);
		if (series.points && series.points.length > 0) {
			const lastpoint = series.points[series.points.length - 1];

			if (lastpoint) {
				//	const formattedValue = AbbreviateNumber.formatValue(lastpoint.y, series.yAxisUnit);
				const yAxisName = series.yAxisName ? series.yAxisName : "y";
				const formattedValue = UnitConverter.convertAndFormat(
					lastpoint.y,
					series.yAxisUnit ? series.yAxisUnit : "COUNT._",
					this.maxValues[yAxisName].unit,
					{
						toFixed: 2,
						space: true,
						normalize: false
					}
				);
				return {
					y:
						+formattedValue.split(" ")[0] % 1 === 0
							? Math.trunc(+formattedValue.split(" ")[0])
							: formattedValue.split(" ")[0],
					unit: formattedValue.split(" ")[1] ? formattedValue.split(" ")[1] : "#"
				};
			}
		} else {
			return { y: "--", unit: "#" };
		}
	},
	/**
	 * Calculate Deviation in type number
	 */
	getDeviation(series) {
		// console.log(series);
		if (series.points && series.points.length > 0) {
			const lastpoint = series.points[series.points.length - 1];
			const secondlastpoint = series.points[series.points.length - 2];
			const yAxisName = series.yAxisName ? series.yAxisName : "y";
			if (lastpoint && secondlastpoint) {
				let deviation = lastpoint.y - secondlastpoint.y;
				let type = "neutral";

				if (deviation > 0) {
					type = "positive";
				} else if (deviation < 0) {
					type = "negative";
					deviation = deviation * -1;
				}

				const covertedValue = UnitConverter.convertAndFormat(
					deviation,
					series.yAxisUnit ? series.yAxisUnit : "COUNT._",
					this.maxValues[yAxisName].unit,
					{
						toFixed: this.noDigitsAfterDeviationDecimal,
						space: true,
						normalize: false
					}
				);

				const deviationObj = {
					value: +covertedValue.split(" ")[0] === 0 ? "" : covertedValue.split(" ")[0],
					unit: covertedValue.split(" ")[1],
					type
				};
				return deviationObj;
			} else {
				return { value: "", type: "neutral", unit: "" };
			}
		} else {
			return { value: "", type: "neutral", unit: "" };
		}
	},
	getSeriesColor(series) {
		if (this.chart && this.type === "chart" && series.name) {
			return this.chart.color(series.name);
		} else if (this.type === "number") {
			return `${series.color} !important`;
		} else if (!series.name) {
			return "transparent !important";
		} else {
			return "var(--dashboard-font-dark)";
		}
	},
	getXminAndXmax() {
		let min, max;

		if (this.xMin) {
			min = this.xMin;
		}
		if (this.xMax) {
			max = this.xMax;
		}
		return {
			min,
			max
		};
	}
};
